import { render, staticRenderFns } from "./EventWizardWhat.vue?vue&type=template&id=0ea8c760&scoped=true&"
import script from "./EventWizardWhat.vue?vue&type=script&lang=js&"
export * from "./EventWizardWhat.vue?vue&type=script&lang=js&"
import style0 from "./EventWizardWhat.vue?vue&type=style&index=0&id=0ea8c760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8c760",
  null
  
)

export default component.exports